export const getPlaceholder = ({
  keepValueDisplay,
  value,
  titleOption,
  defaultValue
}) => (keepValueDisplay ? value : titleOption?.title) || defaultValue;
